import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import ChecklistManager from '../../components/ChecklistManagement/ChecklistManager';

const ChecklistManagement: React.FC = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/safety-equipment');
  };

  return (
    <main
      className="min-h-screen bg-gray-50 py-6"
      aria-labelledby="page-title"
      data-page="checklist-management"
    >
      <div className="max-w-7xl mx-auto px-4">
        <header className="mb-6">
          <div className="flex items-center justify-between mb-4">
            <button
              type="button"
              onClick={handleBack}
              className="inline-flex items-center gap-2 px-4 py-2 rounded-lg text-gray-700 hover:text-gray-900 hover:bg-gray-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-gray-400 transition-colors"
              aria-label="Back to Safety Equipment"
              data-testid="btn-back-safety-equipment"
            >
              <ArrowLeft size={20} aria-hidden="true" />
              <span>Back to Safety Equipment</span>
            </button>

            <p className="text-sm text-gray-500">
              Manage inspection checklists for asset types such as CO2 and Chemical storage.
            </p>
          </div>

          <div>
            <h1 id="page-title" className="text-2xl font-semibold text-gray-900 tracking-tight">
              Inspection Checklist Management
            </h1>
            <p className="text-gray-600 mt-1">
              Create and maintain standardized inspection checklists that automatically map to asset types.
            </p>
          </div>
        </header>

        <section aria-label="Checklist manager" className="relative">
          <ChecklistManager />
        </section>
      </div>
    </main>
  );
};

export default ChecklistManagement;
